import { useState } from 'react';

export default function Footer({ isEnglish }: { isEnglish?: boolean }) {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Newsletter subscription:', email);
    setEmail('');
  };

  const menuItems = isEnglish
    ? [
        { href: '#home', label: 'Home' },
        { href: '#plans', label: '플랜 선택' },
        { href: '#contact', label: '문의 / 환불' },
      ]
    : [
        { href: '#home', label: 'Home' },
        { href: '#event', label: 'Event' },
        { href: '#personal', label: 'Personal' },
        { href: '#biz', label: 'Biz' },
      ];

  const kakaoHref = isEnglish
    ? 'http://pf.kakao.com/_zgdxhX'
    : 'http://pf.kakao.com/_exilzX';

  return (
    <footer id="contact" className="bg-[#0A0A0A] py-6 sm:py-12 md:py-16">
      <div className="max-w-[1400px] mx-auto px-3 sm:px-8">
        <div className="bg-[#1A1A1A] border border-gray-800 rounded-xl sm:rounded-2xl md:rounded-3xl p-4 sm:p-8 md:p-12 lg:p-16 relative overflow-hidden">
          <div className="relative z-10 grid grid-cols-3 sm:grid-cols-2 lg:grid-cols-3 gap-3 sm:gap-10 lg:gap-12">
            <div className="col-span-1">
              <div className="space-y-2 sm:space-y-4">
                <div className="flex items-center gap-1 sm:gap-2">
                  <div className="flex flex-col leading-none">
                    <span className="text-[12px] sm:text-[16px] font-bold text-white">LEXO</span>
                    <span className="text-[8px] sm:text-[10px] text-gray-400 tracking-wide">
                      {isEnglish ? '강한 영어' : '강한 일본어'}
                    </span>
                  </div>
                </div>
                {isEnglish && (
                  <p className="text-[9px] sm:text-[12px] text-gray-500 leading-relaxed hidden sm:block">
                    드라마·영화로 배우는<br />진짜 실전 영어
                  </p>
                )}
              </div>
            </div>

            <div>
              <h4 className="text-[11px] sm:text-[15px] md:text-[16px] font-semibold text-white mb-2 sm:mb-4 md:mb-6">메뉴</h4>
              <ul className="space-y-1.5 sm:space-y-3 md:space-y-4">
                {menuItems.map((item) => (
                  <li key={item.href}>
                    <a href={item.href} className="text-[10px] sm:text-[13px] md:text-[14px] text-gray-400 hover:text-[#14B8A6] transition-colors duration-300 whitespace-nowrap">
                      {item.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-[11px] sm:text-[15px] md:text-[16px] font-semibold text-white mb-2 sm:mb-4 md:mb-6">소셜</h4>
              <ul className="space-y-1.5 sm:space-y-3 md:space-y-4">
                <li>
                  <a href="https://www.instagram.com/lexo_official_?igsh=MWdvamIwazd6amg3NA%3D%3D&utm_source=qr" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 sm:gap-3 text-[10px] sm:text-[13px] md:text-[14px] text-gray-400 hover:text-[#14B8A6] transition-colors duration-300 whitespace-nowrap">
                    <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                      <i className="ri-instagram-line text-[14px] sm:text-[18px]"></i>
                    </div>
                    <span className="hidden sm:inline">Instagram</span>
                  </a>
                </li>
                <li>
                  <a href={kakaoHref} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 sm:gap-3 text-[10px] sm:text-[13px] md:text-[14px] text-gray-400 hover:text-[#14B8A6] transition-colors duration-300 whitespace-nowrap">
                    <div className="w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center">
                      <i className="ri-kakao-talk-fill text-[14px] sm:text-[18px]"></i>
                    </div>
                    <span className="hidden sm:inline">
                      {isEnglish ? 'LEXO 영어 채널' : 'KakaoTalk'}
                    </span>
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative z-10 mt-4 sm:mt-12 md:mt-16 pt-3 sm:pt-6 md:pt-8 border-t border-gray-800">
            <div className="mb-3 sm:mb-6 text-center">
              <div className="text-[9px] sm:text-[12px] text-gray-500 leading-relaxed space-y-0.5">
                <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5">
                  <span>상호: LEXO (렉소)</span>
                  <span className="text-gray-700 hidden sm:inline">|</span>
                  <span>대표자: 이송희</span>
                  <span className="text-gray-700 hidden sm:inline">|</span>
                  <span>사업자등록번호: 572-62-00804</span>
                </p>
                <p className="flex flex-wrap items-center justify-center gap-x-2 gap-y-0.5">
                  <span>통신판매업 신고번호: 제2026-강원양양-0027호</span>
                  <span className="text-gray-700 hidden sm:inline">|</span>
                  <span>주소: 강원도 양양군 물치천로 241</span>
                </p>
                <p>
                  이메일: <a href="mailto:lexojp.help@gmail.com" className="text-gray-400 hover:text-[#14B8A6] transition-colors">lexojp.help@gmail.com</a>
                </p>
                <div className="flex items-center justify-center gap-2 sm:gap-3 mt-1.5 sm:mt-3">
                  <a href="/terms" className="text-gray-500 hover:text-[#14B8A6] transition-colors whitespace-nowrap">이용약관</a>
                  <span className="text-gray-700">|</span>
                  <a href="/privacy" className="text-gray-500 hover:text-[#14B8A6] transition-colors whitespace-nowrap">개인정보처리방침</a>
                </div>
              </div>
            </div>
            <p className="text-[9px] sm:text-[12px] md:text-[13px] text-gray-500 text-center">
              © 2026 <span className="text-[#14B8A6] font-semibold">LEXO</span>. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
